import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPExtraCushion from 'data-hooks/usePDPExtraCushion';
import PDPExtraOptionSelectorUI from './PDPExtraOptionSelectorUI';
const PDPExtraOptionSelector = () => {
  const $ = _c(6);
  const {
    loading,
    error,
    data: t0,
    actions: t1
  } = usePDPExtraCushion();
  const {
    isAdded,
    priceObj
  } = t0;
  const {
    onAdd,
    onRemove
  } = t1;
  if (error) {
    return null;
  }
  let t2;
  if ($[0] !== isAdded || $[1] !== loading || $[2] !== onAdd || $[3] !== onRemove || $[4] !== priceObj) {
    t2 = <PDPExtraOptionSelectorUI loading={loading} priceObj={priceObj} isAdded={isAdded} onAdd={onAdd} onRemove={onRemove} />;
    $[0] = isAdded;
    $[1] = loading;
    $[2] = onAdd;
    $[3] = onRemove;
    $[4] = priceObj;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default PDPExtraOptionSelector;